import React, { useEffect, useState } from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import Constants from "../../../utils/Constants";
import SplashScreen from "../../../components/loader/SplashScreen/SplashScreen";
import { Export, Restart, View } from "@carbon/icons-react";
import SearchHead from "../../../components/custom/SearchHead";
import ReactPaginate from "react-paginate";
import DealershipDetail from "./DealershipDetail";

const Dealership = () => {
  const [page, setPage] = useState(1);
  const [loader, Setloader] = useState(false);
  const [searchparam, setsearchparam] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [showDetail, setShowDetail] = useState(false);

  const DealershipApi = (page) => {
    return axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      params: {
        page: page || 1,
        ...(searchparam ? { search: searchparam } : {}),
        ...(startDate ? { "createdAt[gte]": startDate } : {}),
        ...(endDate ? { "createdAt[lte]": endDate } : {}),
      },
      url: Constants.url + "dealership-applications",
    }).then((res) => {
      return res.data.data;
    });
  };

  const {
    data: DealershipData,
    isLoading,
    refetch,
  } = useQuery({
    queryFn: () => DealershipApi(page),
    queryKey: ["DealershipData", page],
    staleTime: Infinity,
    cacheTime: 1000 * 60 * 60,
  });

  const headers = [
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "Email", key: "email" },
    { label: "Phone", key: "primaryNumber" },
    { label: "Business Name", key: "currentBusinessName" },
    { label: "Status", key: "status" },
  ];

  useEffect(() => {
    refetch();
  }, [searchparam, startDate, endDate]);

  const Refresh = () => {
    Setloader(true);
    refetch().then(() => {
      Setloader(false);
    });
  };

  const handleViewDetails = (application) => {
    setSelectedApplication(application);
    setShowDetail(true);
  };

  const handleCloseDetail = () => {
    setShowDetail(false);
    setSelectedApplication(null);
  };

  if (showDetail && selectedApplication) {
    return (
      <DealershipDetail
        data={selectedApplication}
        onBack={handleCloseDetail}
      />
    );
  }

  return (
    <>
      {!isLoading && !loader ? (
        <div className="uk-grid" uk-grid="">
          <div className="uk-width-1-1">
            <SearchHead
              searchparam={searchparam}
              RefreshFunc={Refresh}
              headers={headers}
              CsvData={DealershipData?.applications || []}
              Filename={"Dealership_applications_data.csv"}
              setsearchparam={setsearchparam}
              endpoint="dealership-applications"
              startDate={startDate}
              endDate={endDate}
              setStartdate={setStartDate}
              setEndDate={setEndDate}
            />
            <div className="analyticsTableWrp uk-overflow-auto ">
              <table className="uk-table uk-table-striped  ">
                <thead className="table-header-shadow ">
                  <tr>
                    <th>S.No</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Business Name</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {DealershipData?.applications?.map((item, index) => (
                    <tr key={item._id}>
                      <td>{(page - 1) * 100 + (index + 1)}</td>
                      <td>{item.firstName || "-"}</td>
                      <td>{item.lastName || "-"}</td>
                      <td>{item.email || "-"}</td>
                      <td>{item.primaryNumber || "-"}</td>
                      <td>{item.currentBusinessName || "-"}</td>
                      <td>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 14px",
                            borderRadius: "16px",
                            fontSize: "12px",
                            fontWeight: "600",
                            textTransform: "capitalize",
                            backgroundColor: item.status === "pending" 
                              ? "rgb(240 154 30)" 
                              : item.status === "approved" 
                              ? "#32d296" 
                              : "#f0506e",
                            color: "#fff"
                          }}
                        >
                          {item.status || "-"}
                        </span>
                      </td>
                      <td>
                        <button
                          className="uk-button uk-button-text"
                          onClick={() => handleViewDetails(item)}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            color: "#666",
                            padding: "0",
                            fontSize: "14px",
                            fontWeight: "500"
                          }}
                        >
                          <View size={18} />
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className=" paginationcard uk-card uk-card-default ">
                <ReactPaginate
                  previousLabel={"←"}
                  nextLabel={"→"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={Math.ceil(
                    (DealershipData?.results || 0) / 100
                  )}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={2}
                  onPageChange={(e) => setPage(e.selected + 1)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  forcePage={page - 1}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <SplashScreen />
      )}
    </>
  );
};

export default Dealership;
